import { InjectionToken } from '@angular/core';

export const CORE_MESSAGES_SERVICE = new InjectionToken<any>('CoreMessagesService');
